import apiClient from './apiClient';

export async function getCurrentUser() {
    return apiClient.get('current-user?includeInternal=true');
}